$(document).on('click','.btn_success:not(.btn_inverse)', function() {

    $(this).text('В корзине');
    $(this).addClass('btn_inverse');
    if (!$('.header__link_cart').hasClass('header__link_cart-js')) {
        
        $('.header__link_cart').addClass('header__link_cart-js');
     
 setTimeout(function(){
            $('.header__link_cart').removeClass('header__link_cart-js');
          }, 2500);
    }
    setTimeout(function(){
        $('.dn-js').fadeIn();
    }, 100);
});   


$(document).on('click','.subs_product', function() {

    $('#subsribe_product').modal('show');
});   